import { render, staticRenderFns } from "./amendment.vue?vue&type=template&id=025ee150"
import script from "./amendment.vue?vue&type=script&lang=js"
export * from "./amendment.vue?vue&type=script&lang=js"
import style0 from "./amendment.vue?vue&type=style&index=0&id=025ee150&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports